import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AnnouncementRoundedIcon from '@mui/icons-material/AnnouncementRounded';
import SettingsIcon from '@mui/icons-material/SettingsApplicationsRounded';
import SchemaIcon from '@mui/icons-material/Schema';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import { SvgIconComponent } from '@mui/icons-material';

export type NavigationPage = 'home' | 'automations' | 'tasks' | 'org-config' | 'canonicals' | 'scripts' | 'runs';

export type NavigationItem = {
  id: NavigationPage;
  label: string;
  description?: string;
  icon: SvgIconComponent;
  route: string;
};

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'automations',
    label: 'Automations',
    description: 'Visualize fluxos automáticos implementados nas organizações.',
    icon: AutoAwesomeIcon,
    route: '/automations',
  },
  {
    id: 'tasks',
    label: 'Tasks',
    description: 'Visualize as tarefas relacionadas a erros nos fluxos da equipe de Solutions.',
    icon: AnnouncementRoundedIcon,
    route: '/tasks',
  },
  {
    id: 'canonicals',
    label: 'Canonicals',
    description: 'Gerencie recursos canônicos desenvolvidos pela equipe de Solutions.',
    icon: SchemaIcon,
    route: '/canonicals',
  },
  {
    id: 'org-config',
    label: 'Aliare (LEGACY)',
    description: 'Configure credenciais e flags por organização para a integração Aliare.',
    icon: SettingsIcon,
    route: '/org-config',
  },
  {
    id: 'scripts',
    label: 'Scripts',
    description: 'Gerencie e execute scripts de automação.',
    icon: FileUploadIcon,
    route: '/scripts',
  },
  {
    id: 'runs',
    label: 'Runs',
    description: 'Histórico de execuções das automações (sucesso e falha) por organização.',
    icon: ReceiptLongRoundedIcon,
    route: '/runs',
  },
];
